import { useCallback, useState } from "react";

type ExpandMode = "none" | "allExpanded" | "allCollapsed";

export function useExpandCollapseAll(startMode: ExpandMode = "none") {
  const [mode, setMode] = useState<ExpandMode>(startMode);

  const toggle = useCallback(() => {
    setMode((prev) =>
      prev === "allExpanded" ? "allCollapsed" : "allExpanded"
    );
  }, []);

  const reset = useCallback(() => setMode("none"), []);

  return {
    mode,
    toggle,
    reset,
    isAllExpanded: mode === "allExpanded",
    isAllCollapsed: mode === "allCollapsed",
  };
}
